// extracted by mini-css-extract-plugin
export default {"shareLink":"Lesson__shareLink___ClMWd"};